import Header from "../../components/headerBlue/header.component";
import { Link } from "react-router-dom";

const InvalidTokenPage = () => (
    <>
        <Header />
        <div className="w-full min-h-[calc(100vh-60px)] flex items-center justify-center bg-white">
            <div className="max-w-lg mx-auto p-8 text-center">
                <h1 className="text-4xl font-bold text-gray-900 mb-4">
                    Invalid Token
                </h1>
                <h2 className="text-xl text-gray-600 mb-4">
                    The token you provided is invalid or has expired.
                </h2>
                <p className="text-gray-500">
                    Please{" "}
                    <Link
                        to="/signin"
                        className="text-primary hover:text-primary-dark transition-colors duration-200"
                    >
                        try signing in
                    </Link>{" "}
                    or{" "}
                    <Link
                        to="/resetpassword"
                        className="text-primary hover:text-primary-dark transition-colors duration-200"
                    >
                        request a new password
                    </Link>
                    .
                </p>
            </div>
        </div>
    </>
);

export default InvalidTokenPage;
